// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Let your delight be in the Lord&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and he will give you your heart&#146;s desire.<br> </p> </div></div>";
// Exports
module.exports = code;